import { z } from 'zod';
import { CONTROLE_CANAUX, CONTROLE_RESULTATS } from '../constants/statuses.js';
import { paginationQuerySchema } from './common.js';
/**
 * Vérification / contrôle de carte (Sprint 6a) — schémas canoniques du module,
 * utilisés à la fois par `apps/api/src/modules/controle/controle.routes.ts`
 * (validation) et par `apps/web/src/features/controle/api.ts` (types de
 * réponse ; ce dernier garde ses propres interfaces de réponse, comme le fait
 * déjà le module logistique — seuls les schémas de *requête* sont partagés).
 *
 * Méthode `nfc` : hors périmètre matériel ce sprint (aucun lecteur NFC branché
 * — voir docs/hardware-integration.md). En attendant le matériel réel, le tag
 * NFC encodera le même payload signé HMAC que le QR imprimé sur la carte
 * (`apps/api/src/lib/card-qr.ts`) : `nfc` accepte donc ici exactement la même
 * forme de valeur que `qr` (le `qrCodeValue` signé). `biometrie`, listée dans
 * `CONTROLE_METHODES` pour un usage futur, n'est pas une méthode de *saisie*
 * de ce endpoint de vérification et reste hors périmètre de ce sprint.
 */
export const CONTROLE_METHODES_SAISIE = ['qr', 'nfc', 'manuel'];
export const verifierCarteSchema = z.object({
    canalControle: z.enum(CONTROLE_CANAUX),
    methodeControle: z.enum(CONTROLE_METHODES_SAISIE),
    /** QR/NFC : le `qrCodeValue` signé scanné. Manuel : le numéro de carte saisi. */
    valeur: z.string().trim().min(1).max(500),
    lieuControle: z.string().trim().max(160).optional(),
    referenceTerminal: z.string().trim().max(80).optional(),
});
export const listControlesQuerySchema = paginationQuerySchema.extend({
    resultatControle: z.enum(CONTROLE_RESULTATS).optional(),
    canalControle: z.enum(CONTROLE_CANAUX).optional(),
    dateDebut: z.coerce.date().optional(),
    dateFin: z.coerce.date().optional(),
});
//# sourceMappingURL=controle.js.map